import React, { useState, useEffect } from "react";
import search from "../../../assets/svg/search.svg";
import FillStartIcon from "../../../assets/svg/fill-star.svg";
import StartIcon from "../../../assets/svg/star.svg";
import ProductImage from "../../../assets/images/our-product.png";
import { GetCart, MoveItemToCartOrWishlist, RemoveCartItem } from "../../../Services/CartService"; // 👈 use your service
import { getImageUrl, handleImageError } from "../../../utils/imageUtils";


const MyFavourites = () => {
  const [cartItems, setCartItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadingItemId, setLoadingItemId] = useState(null); // ✅ track loading button

  // ✅ Fetch cart items
  const fetchCartItems = async (term = "") => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      console.error("User ID not found");
      setLoading(false);
      return;
    }

    try {
      const params = { userId: parseInt(userId), shoppingCartTypeId: 1 }; // Favourites type
      const response = await GetCart(params);

      let items = response?.data || [];

      // ✅ Optional: filter locally by search term (productName)
      if (term) {
        const lowerTerm = term.toLowerCase();
        items = items.filter((item) =>
          item.productName?.toLowerCase().includes(lowerTerm)
        );
      }

      setCartItems(items);
    } catch (error) {
      console.error("Error fetching cart items:", error);
      setCartItems([]);
    } finally {
      setLoading(false);
    }
  };

  const handleBuy = async (itemId) => {
    try {
      setLoadingItemId(itemId); // start loader on button

      const params = {
        cartItemId: parseInt(itemId),
        shoppingCartType: 2, // 1 = cart, 2 = wishlist (assuming)
      };

      const response = await MoveItemToCartOrWishlist(params);

      if (response?.status) {

        // ✅ Refetch favourites after successful move
        await fetchCartItems(searchTerm);

        // ✅ Update cart count in header
        window.dispatchEvent(new Event('cartUpdated'));
      }
    } catch (error) {
      console.error("Error moving item:", error);
    } finally {
      setLoadingItemId(null); // stop loader
    }
  };

  const handleRemove = async (itemId) => {
    try {
      setLoadingItemId(itemId); // start loader on button

      const response = await RemoveCartItem(parseInt(itemId));

      if (response?.status) {
        // ✅ Refetch favourites after successful removal
        await fetchCartItems(searchTerm);
      }
    } catch (error) {
    } finally {
      setLoadingItemId(null); // stop loader
    }
  };

  // ✅ Initial Load
  useEffect(() => {
    fetchCartItems();
  }, []);

  // ✅ Auto search with debounce
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchCartItems(searchTerm);
    }, 400);
    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  return (
    <div className="main-content">
      <div className="d-flex align-items-center justify-content-between mb_28 stuff-title-order">
        <h2 className="mb-0 fw_600 fs_24 lh-1">Favourites ({cartItems.length})</h2>
        <div className={"form-input search-field"}>
          <input
            type="text"
            className="form-control"
            id="search"
            placeholder="Search Your Product"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <img src={search} alt="Search" className="search-icon" />
        </div>
      </div>

      {loading ? (
        <div className="text-center py_50">
          <h5 className="fs_18 fw_400 text-muted">Fetching your favourites...</h5>
        </div>
      ) : cartItems.length === 0 ? (
        <div className="text-center py_50">
          <h5 className="fs_20 fw_500 text-muted">No Favourites Found</h5>
        </div>
      ) : (
        <div className="order-list-box">
          {cartItems.map((item) => (
            <div key={item.id} className="cart-grid d-flex align-items-center justify-content-between gap-2 mb_30">
              <div className="d-flex align-items-start">
                <div className="img-wrapper">
                  <img
                    className="img-fluid"
                    src={getImageUrl(item.path, ProductImage)} // ✅ helper used
                    onError={(e) => handleImageError(e, ProductImage)}
                    alt={item.productName}
                  />
                </div>

                <div>
                  <div className={" mb_10"}>
                    <h6 className={"fs_24 fw_700 text-color mb-0"}>
                      {item.productName} ({item.weight}KG)
                    </h6>
                  </div>
                  <div className={"tag-list d-flex align-items-center"}>
                    {item.attributes.subProducts.map((subProduct) => (
                      <div key={subProduct.id} className="tag py_10 px_10 fs_12 text-color">
                        {subProduct.name} {subProduct.weight}
                      </div>
                    ))}
                    {item.attributes.attributes.map((attr) => (
                      <div key={attr.id} className="tag py_10 px_10 fs_12 text-color">
                        {attr.value}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className={''}>
                {/* Ratings Example */}
                <div className={""}>
                  <p className={"fs_18 fw_400 lh-1-5 text-color"}>
                    Product Rating {item.averageRating > 0 && (item.averageRating)}
                    {/* {item.review !== 1 ? "s" : ""} */}
                  </p>

                  <div className={"d-flex align-items-center gap-2 mb-2"}>
                    {[...Array(5)].map((_, index) => (
                      <img
                        key={index}
                        src={index < item.averageRating ? FillStartIcon : StartIcon}
                        className={"img-fluid"}
                        alt=""
                      />
                    ))}
                  </div>
                </div>
                <div className="d-flex gap-2">
                  <button
                    className="btn btn-sm btn-primary text-uppercase"
                    style={{ backgroundColor: "#a37c4d", borderColor: "#a37c4d" }}
                    onClick={() => handleBuy(item.id)}      // 👈 lowercase id
                    disabled={loadingItemId === item.id}    // 👈 lowercase id
                  >
                    {loadingItemId === item.id ? (          // 👈 lowercase id
                      <div
                        className="spinner-border spinner-border-sm text-light"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    ) : (
                      "Add To Cart"
                    )}
                  </button>
                  <button
                    className="btn btn-sm btn-primary text-uppercase"
                    style={{ backgroundColor: "#a37c4d", borderColor: "#a37c4d" }}
                    onClick={() => handleRemove(item.id)}
                    disabled={loadingItemId === item.id}
                  >
                    {loadingItemId === item.id ? (
                      <div
                        className="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    ) : (
                      "Remove"
                    )}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyFavourites;